import { RootState } from "../../store";
import { ProviderAccessType } from "../../../services/cloudchipr.api";

export const providerAccessTypeSelector = (
  state: RootState,
): ProviderAccessType => state.accountSetup.providerAccessType;
